import { defineMessages } from 'react-intl';

export const generalMessages = defineMessages({
  cancel: { id: 'general.cancel' },
  dashboard: { id: 'general.dashboard' },
  edit: { id: 'general.edit' },
  editor: { id: 'general.editor' },
  exitCourse: { id: 'general.exit_course' },
  library: { id: 'general.library' },
  menu: { id: 'general.menu' },
  reset: { id: 'general.reset' },
  settings: { id: 'general.settings' },
  send: { id: 'general.send' },
  about: { id: 'general.about' },
  platformUrl: { id: 'general.platform_url' },
  platformMarketingUrl: { id: 'general.platform_marketing_url' },
  yes: { id: 'general.yes' },
  contentNotAvailable: {
    id: 'general.content_offline',
  },
  platformName: {
    id: 'general.platform_name',
  },
  poweredBy: {
    id: 'general.powered_by',
  },
  overview: {
    id: 'general.overview',
  },
  lessons: {
    id: 'general.lessons',
  },
});
